<div class="outer-div">
  @if (label && label != '') {
    <p class="input-label">{{ label }}</p>
  }
  @for (option of options; track option) {
    <label
      [for]="formLabel + '_' + option.value"
      [attr.checked]="checked(option)"
      [attr.disabled]="disable"
      checked="option.checked"
      class="bord-rad"
    >
      <input
        #input
        type="radio"
        [id]="formLabel + '_' + option.value"
        [name]="formControlName"
        [(ngModel)]="control.value"
        (change)="onInputChange($event, option)"
        [disabled]="disable"
      />
      <div>
        @if (option.icon) {
          <pr-icon [name]="option.icon" style="float: left"></pr-icon>
        }
        {{ option.label }}
      </div>
    </label>
  }
</div>
